import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import answerListReducer from '../features/answerList/answerListSlice';
import errorListReducer from '../features/errorList/errorListSlice';
import contactInfoReducer from '../features/contactInfo/contactInfoSlice';

export const store = configureStore({
  reducer: {
    answerList: answerListReducer,
    errorList: errorListReducer,
    contactInfo: contactInfoReducer
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;